import { render, staticRenderFns } from "./PortalStatusPill.vue?vue&type=template&id=7abd8c02&scoped=true&"
import script from "./PortalStatusPill.vue?vue&type=script&lang=js&"
export * from "./PortalStatusPill.vue?vue&type=script&lang=js&"
import style0 from "./PortalStatusPill.vue?vue&type=style&index=0&id=7abd8c02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abd8c02",
  null
  
)

export default component.exports